import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { jobData } from 'features/job/store'
import { useJob } from 'features/job/hooks'
import { SaveControl } from 'features/job/components/JobActionControls'

export const Save = () => {
  const { t } = useTranslation()

  const dispatch = useDispatch()

  const { job } = useJob()

  const onSuccess = data => {
    dispatch(jobData.updateData({ ...data }))
  }

  return (
    <>
      <SaveControl
        saved={job?.saved}
        id={job?.id}
        onSuccess={onSuccess}
        className={'font-size-18 fw-medium'}
      />
    </>
  )
}

Save.propTypes = {}
